/* eslint-disable no-console */
import {Flex, Select} from 'antd';
import React, {memo, useEffect, useMemo, useState} from 'react';

import carbonNegative from '../../../../assets/carbonNegative.png';
import carbonPositive from '../../../../assets/carbonPositive.png';
import fnImage from '../../../../assets/fnImage.png';
// import Loader from '../../../../components/Loader/Loader';
import MapComp from '../../../../components/MapComponents/MapComp';
import PageContent from '../../../../components/PageContent/PageContent';
import MainTableTitle from '../../../../components/Table/Utils/MainTableTitle';
import {getUniqueArray} from '../../../../shared/commonFunctions';
import {formatIndian} from '../../../../utils/formatIndian';
// import useDataStore from '../../../../store/dataStore/dataStore';

const ActivityPerformance: React.FC<{
  data: any;
}> = ({data}) => {
  const [continent, setContinent] = useState<string | undefined>('All');
  const [countryOptions, setCountryOptions] = useState<any[]>();
  // const {activityPerformance} = useDataStore.getState();
  // const {facilitiesData} = activityPerformance;
  const [mainData, setMainData] = useState(data ?? []);

  const [stateOptions, setStateOptions] = useState<any[]>();
  const [country, setCountry] = useState<string | undefined>(undefined);
  const [state, setState] = useState<string | undefined>(undefined);
  const [cityMap, setCityMap] = useState<any[]>([]);
  const mapRef: any[] = [];
  const [selectedFacility, setSelectedFacility] = useState<string | undefined>(
    undefined
  );

  const singleRef: any[] = [];

  useEffect(() => {
    setMainData(data?.facilitiesData ?? []);
  }, [data]);

  const positiveFacility = useMemo(() => {
    if (mainData?.length > 0) {
      return mainData?.filter((item: any) => {
        return item?.emissions?.value < item.benchmark;
      });
    } else {
      return [];
    }
  }, [mainData]);

  useEffect(() => {
    if (mainData.length > 0) {
      const stateFlat = mainData?.filter((item: any) => {
        return continent === 'All'
          ? country
            ? item?.country === country
            : true
          : item.continent === continent &&
              (!country || item?.country === country);
      });

      setCountryOptions(
        mainData?.map((item: any) => {
          return {
            value: item?.country,
            label: item?.country,
            continent: item.continent
          };
        })
      );

      setStateOptions(
        mainData?.map((item: any) => {
          return {
            value: item?.state,
            label: item?.state,
            country_id: item.country
          };
        })
      );

      setCityMap(
        stateFlat
          ?.filter((item: any) => {
            return state ? item?.state === state : true;
          })
          ?.map((item: any, index: number) => {
            return {...item, _id: index};
          })
      );
    }
  }, [continent, country, state, mainData]);

  useEffect(() => {
    const index = cityMap?.findIndex((t) => t?._id === selectedFacility);
    singleRef[index]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }, [selectedFacility]);

  return (
    <PageContent>
      <Flex className="activityPerformance">
        <MainTableTitle title="Activity Performance" />
        <Flex className="contentFlex">
          <Flex className="mapFlex">
            <MapComp
              type="metricsMap"
              mapData={cityMap}
              markerRef={mapRef}
              setSelectedFacility={setSelectedFacility}
            />
          </Flex>
          <Flex className="dataFlex">
            <Flex className="topFlex">
              <div className="facilityNumber">
                <div className="fNFlex">
                  <div>
                    <img src={fnImage} height={48} width={48} />
                  </div>
                  <div className="fNumber">{mainData.length}</div>
                  <div className="fNumberText">No.</div>
                </div>
                <div className="fText">TOTAL NO. OF FACILITY</div>
              </div>
              <div className="cFlex">
                <div className="cNegativeFlex">
                  <div className="cPSymbol">
                    <img src={carbonNegative} height={21} width={21} />
                  </div>
                  <div className="cPInfo">
                    <div className="cNNumber">
                      {mainData.length - positiveFacility.length}
                    </div>
                    <div className="cNText">Above Benchmark</div>
                  </div>
                </div>
                <div className="cPositiveFlex">
                  <div className="cPSymbol">
                    <img src={carbonPositive} height={21} width={21} />
                  </div>
                  <div className="cPInfo">
                    <div className="cPNumber">{positiveFacility.length}</div>
                    <div className="cPText">Below Benchmark</div>
                  </div>
                </div>
              </div>
            </Flex>
            <Flex className="listFlex">
              <Flex className="selectTabs">
                <Select
                  className="selectContinents"
                  placeholder="All Continents"
                  options={
                    getUniqueArray(mainData, 'continent')
                      .map((item) => {
                        return {value: item.continent, label: item.continent};
                      })
                      .concat({label: 'All', value: 'All'})
                      .reverse() ?? [{label: 'All', value: 'All'}]
                  }
                  onChange={(e) => {
                    setContinent(e);
                    setCountry(undefined);
                    setState(undefined);
                  }}
                  value={continent}
                />
                <div>
                  <Select
                    allowClear
                    className="selectCountry"
                    placeholder="By Country"
                    options={
                      getUniqueArray(countryOptions ?? [], 'value')?.filter(
                        (item) => {
                          return continent === 'All'
                            ? true
                            : item.continent === continent;
                        }
                      ) ?? []
                    }
                    onChange={(e) => {
                      setCountry(e);
                      setState(undefined);
                    }}
                    value={country}
                  />
                  <Select
                    allowClear
                    className="selectStates"
                    placeholder="By States"
                    options={
                      getUniqueArray(stateOptions ?? [], 'value')?.filter(
                        (item) => {
                          return item.country_id === country;
                        }
                      ) ?? []
                    }
                    onChange={(e) => {
                      setState(e);
                    }}
                    value={state}
                  />
                </div>
              </Flex>
            </Flex>
            <Flex className="countryList" vertical={true}>
              {cityMap?.map((item, index) => {
                const {
                  name,
                  emissions: {value, unit},
                  benchmark
                } = item;

                const isNegative = value > benchmark;

                return (
                  <Flex
                    ref={(ref: any) => singleRef.push(ref)}
                    className="countryDiv"
                    key={index}
                    justify="space-between"
                    align="center"
                    onClick={() => {
                      mapRef[index].fire('click');
                      setSelectedFacility(item._id);
                    }}
                    style={{
                      backgroundColor:
                        selectedFacility === item._id ? '#DDF7FA39' : '#FFFFFF',
                      borderLeft:
                        selectedFacility === item._id ? '2px solid #3BB3C1' : ''
                    }}
                  >
                    <div className="countryLabel">{name}</div>
                    <div
                      className={`countryValue ${
                        isNegative ? 'negative' : 'positive'
                      }`}
                    >{`${formatIndian(value)} ${unit}`}</div>
                  </Flex>
                );
              })}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </PageContent>
  );
};

export default memo(ActivityPerformance);
